
import React, { useState } from 'react';
import AppContext from './AppContext';


const AppProvider = ({ children }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [line1, setLine1] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [postal, setPostal] = useState('');
  const [apt, setApt] = useState('')
  const [zipcodes, setZipcodes] = useState('');
  const [buyNow, setBuyNow] = useState('home');
  const [clientSecret, setClientSecret] = useState(null);
  const [loadingHeader, setLoadingHeader] = useState(false);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedStateName, setSelectedStateName] = useState();
  const [selectedMetro, setSelectedMetro] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(19900);
  const [leadsCount, setLeadsCount] = useState(500);
  const [billingFrequency, setBillingFrequency] = useState('Monthly');
  const [stateAverages, setStateAverages] = useState({});
  const setStateAverage = (stateCode, average) => {
    setStateAverages((prev) => ({ ...prev, [stateCode]: average }));
  };
  const [paymentId, setPaymentId] = useState(null);

  return (
    <AppContext.Provider value={{
      name, setName, email, setEmail, phone, setPhone, line1, setLine1,
      city, setCity, state, setState, postal, setPostal, apt, setApt, zipcodes, setZipcodes,
      buyNow, setBuyNow, clientSecret, setClientSecret, loadingHeader, setLoadingHeader,
      selectedState, setSelectedState, selectedStateName, setSelectedStateName,
      selectedMetro, setSelectedMetro, selectedPrice, setSelectedPrice, leadsCount, setLeadsCount,
      billingFrequency, setBillingFrequency,
      stateAverages, setStateAverage,
      paymentId, setPaymentId,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
